import { BrandVariants, Theme, createDarkTheme, createLightTheme } from "@fluentui/react-components";

export const cosmeWidgetTheme: BrandVariants = {
    10: "#030202",
    20: "#1A1616",
    30: "#2B2324",
    40: "#3A2E2F",
    50: "#49393A",
    60: "#584446",
    70: "#685052",
    80: "#785C5F",
    90: "#89696C",
    100: "#9A7579",
    110: "#AB8286",
    120: "#B69295",
    130: "#C2A2A5",
    140: "#CDB2B4",
    150: "#D8C3C4",
    160: "#E3D3D4",
};

export const lightTheme: Theme = {
    ...createLightTheme(cosmeWidgetTheme),
};;

export const darkTheme: Theme = {
    ...createDarkTheme(cosmeWidgetTheme),
};

darkTheme.colorBrandForeground1 = cosmeWidgetTheme[110];
darkTheme.colorBrandForeground2 = cosmeWidgetTheme[120];

export type ColorMap = {
    [key: string]: string;
}
export type NameDictionaly = {
    [key: string]: string;
}

export const MediaTheme: ColorMap = {
    // "www.biteki.com": "#ff789f",
    // "maquia.hpplus.jp": "#f36586",
    // "i-voce.jp": "#e4007f",
    "www.biteki.com": "#CDEDF1",
    "maquia.hpplus.jp": "#f36586",
    "i-voce.jp": "#CCCCCC",
}

export const MediaName: NameDictionaly = {
    "www.biteki.com": "美的.com",
    "maquia.hpplus.jp": "MAQUIA online",
    "i-voce.jp": "i-Voce",

}
console.log();